import React, { createContext, useContext, useEffect, useState } from 'react';

const KompresorContext = createContext();

export const useKompresor = () => useContext(KompresorContext);

export const KompresorProvider = ({ children }) => {
  const [kompresorlar, setKompresorlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Backend'den yükle, localStorage'a cache'le
  useEffect(() => {
    const loadData = async () => {
      try {
        // Önce localStorage'dan hızlı yükle (instant UI)
        const cached = localStorage.getItem('kompresorKayitlari');
        if (cached) {
          setKompresorlar(JSON.parse(cached));
        }

        // Sonra backend'den güncel veriyi çek
        const response = await fetch('/api/kayitlar');
        if (!response.ok) throw new Error('API hatası');
        
        const data = await response.json();
        setKompresorlar(data);
        localStorage.setItem('kompresorKayitlari', JSON.stringify(data));
      } catch (err) {
        console.error('Veri yükleme hatası:', err);
        setError(err.message);
        // Hata durumunda localStorage'daki veriyi kullan
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // ✅ Backend'e de gönder
  const yeniKompresorEkle = async (yeniVeri) => {
    try {
      const response = await fetch('/api/kaydet', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(yeniVeri)
      });

      if (!response.ok) throw new Error('Kaydetme hatası');

      // Backend başarılı, state'i güncelle
      setKompresorlar(prev => [...prev, yeniVeri]);
      localStorage.setItem('kompresorKayitlari', JSON.stringify([...kompresorlar, yeniVeri]));
    } catch (err) {
      console.error('Ekleme hatası:', err);
      setError(err.message);
    }
  };

  // ✅ Backend'den de sil
  const tumKompresorleriSil = async () => {
    try {
      // Her kaydı tek tek sil
      for (const kayit of kompresorlar) {
        await fetch('/api/kayitlar/sil', {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            firma: kayit.firma,
            model: kayit.model,
            seriNo: kayit.seriNo
          })
        });
      }

      setKompresorlar([]);
      localStorage.setItem('kompresorKayitlari', JSON.stringify([]));
    } catch (err) {
      console.error('Silme hatası:', err);
      setError(err.message);
    }
  };

  // ✅ Manuel refresh fonksiyonu
  const refreshData = async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/kayitlar');
      const data = await response.json();
      setKompresorlar(data);
      localStorage.setItem('kompresorKayitlari', JSON.stringify(data));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <KompresorContext.Provider value={{ 
      kompresorlar, 
      loading, 
      error, 
      yeniKompresorEkle, 
      tumKompresorleriSil, 
      refreshData 
    }}>
      {children}
    </KompresorContext.Provider>
  );
};